"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateMomentTags = void 0;

var _getProperty = require("./getProperty");

var generateMomentTags = function generateMomentTags(moment) {
  var onlyThirds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var tags = []; // protect against null or undefined

  if (!moment) {
    return [];
  }

  var thirds = [];
  var keywords = [];
  var type = "";

  if (!!moment.meta) {
    thirds = (0, _getProperty.getProperty)("meta.thirds", moment, null);
    keywords = (0, _getProperty.getProperty)("meta.keywords", moment, null);
    type = (0, _getProperty.getProperty)("meta.type", moment, null);
  } else {
    thirds = (0, _getProperty.getProperty)("thirds", moment, null);
    keywords = (0, _getProperty.getProperty)("keywords", moment, null);
    type = (0, _getProperty.getProperty)("type", moment, null);
  } // third tag


  if (thirds && thirds.length > 1) {
    if (thirds[0] === thirds[1]) {
      tags.push({
        name: thirds[0]
      });
    } else {
      tags.push({
        name: thirds[0] + " to " + thirds[1]
      });
    }
  }

  if (onlyThirds) {
    return tags;
  }

  var homeBox = false;
  var awayBox = false;
  var packing = false;
  var home = false;
  var away = false;

  if (keywords) {
    homeBox = keywords.includes("home box");
    awayBox = keywords.includes("away box");
    packing = keywords.includes("packing");
    away = keywords.includes("away");
    home = keywords.includes("home");
  }

  if (type) {
    if (type.includes("touch chain")) {
      tags.push({
        name: "touch-chain"
      });
    } else if (type.includes("touch")) {
      tags.push({
        name: "touch"
      });
    }

    if (type.includes("key")) {
      if (thirds.length > 1 && thirds[0] === "defensive") {
        tags.push({
          name: "away-goal"
        });
      } else {
        tags.push({
          name: "goal"
        });
      }
    }

    if (type.includes("goalkeeper") || homeBox || awayBox) {
      tags.push({
        name: "box"
      });
    }

    if (away && packing) {
      tags.push({
        name: "defensive breakdown"
      });
    } else if (home && packing) {
      tags.push({
        name: "progression"
      });
    } else if (type.includes("packing")) {
      tags.push({
        name: "progression"
      });
    } else if (type.includes("dive")) {
      tags.push({
        name: "dive"
      });
    }
  }

  tags = tags.filter(function (t) {
    return t && t.name && t.name.length > 0;
  });
  return tags;
};

exports.generateMomentTags = generateMomentTags;